var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-view',{attrs:{"title":"Bitácoras"}},[_c('div',{staticClass:"container-fluid mt-4"},[_c('History')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }